import GenericTabs from '@ui-components/Tabs/GenericTabs'
import React, { useEffect, useState } from 'react'
import Organizational from './Organizational/Organizational';
import { MyNotificationsConfig } from './MyNotifications/MyNotifications';
import CustomerSettings from './CustomerSettings/Customersettings';
import GenericButton from '@ui-components/Button/GenericButton';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@redux/hooks';

export default function NotificationsPage() {

  const [isOrgConfigEnabled, setIsOrgConfigEnabled] = useState(false);
  const navigate = useNavigate();
  const tenantType = useAppSelector((s) => s.userProfile.TenantType);

  //Define the full list of tabs
  const ALL_TABS = [
    "Organizational",
    "My Notifications",
    "Customer Settings",
  ] as const;

  //Visible for this role
  const visibleTabs: ReadonlyArray<string> =
  tenantType === "CUSTOMER"
    ? ["My Notifications"]
    : (tenantType === "PARTNER" || tenantType === "GLOBAL_ADMIN")
      ? ["Organizational", "My Notifications", "Customer Settings"]
      : ALL_TABS;

  //Track the active tab—always initialize to the first visible one
  const [activeTab, setActiveTab] = useState<string>(visibleTabs[0]);

  //If tenantType changes (or we switch roles), reset activeTab
  useEffect(() => {
    if (!visibleTabs.includes(activeTab)) {
      setActiveTab(visibleTabs[0]);
    }
  }, [tenantType, visibleTabs, activeTab]);

  //Content mapping
  const tabContents: Record<string, JSX.Element> = {
    Organizational:      
    <Organizational
      isOrgConfigEnabled={isOrgConfigEnabled}
      onOrgConfigChange={setIsOrgConfigEnabled}
    />,
    "My Notifications": 
    <MyNotificationsConfig
      onConfigChange={setIsOrgConfigEnabled}
      isOrgConfigEnabled={isOrgConfigEnabled}
    />,
    "Customer Settings": <CustomerSettings />,
  };

  const handleHistory = () => {
    navigate("/kontrol/notifications-history")
  };
  return ( 
    <>
      <div className="flex items-center justify-between">
      <div className="w-[60%]">
        <GenericTabs
          tabs={visibleTabs.map((label) => ({ label, value: label }))}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
        <GenericButton onClick={handleHistory} label="View History" />
      </div>
      <div className="mt-6">
        {tabContents[activeTab]}
      </div>
    </>
  )
}
